import React from "react";
import { ReactComponent as LogoIcon } from "@/assets/logo/union_ver1.svg?react";
import { ReactComponent as AudionIcon } from "@/assets/logo/logo_ver1.svg?react";
import { LogoContainer } from "./styles";

interface LogoProps {
  isCollapsed: boolean;
}

export const Logo: React.FC<LogoProps> = ({ isCollapsed }) => (
  <LogoContainer>
    {isCollapsed ? (
      <LogoIcon />
    ) : (
      <>
        <LogoIcon style={{ width: "29px", height: "28px" }} />
        <AudionIcon style={{ width: "77px", height: "19px" }} />
      </>
    )}
  </LogoContainer>
);
